import moment from 'moment';

export function getDateTimeDisplayText(timestamp) {
  if (!timestamp) {
    return null;
  }
  const mom = moment(timestamp, 'YYYY-MM-DD HH:mm:ss');
  return mom.format('MMM DD, YYYY HH:mm');
}
